import React from 'react';
import { Link } from 'react-router-dom';

const headerStyles = {
  header: {
    backgroundColor: '#fff',
    boxShadow: '0 2px 4px rgba(0,0,0,0.1)',
    padding: '12px 20px',
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
  },
  logo: {
    display: 'flex',
    alignItems: 'center',
    gap: '10px',
    textDecoration: 'none',
  },
  logoText: {
    fontSize: '1.5rem',
    fontWeight: 'bold',
    color: '#0066cc',
    margin: 0,
  },
  nav: {
    display: 'flex',
    gap: '20px',
    alignItems: 'center',
  },
  navLink: {
    color: '#444',
    textDecoration: 'none',
    padding: '8px 12px',
    borderRadius: '4px',
    transition: 'background-color 0.2s',
    fontWeight: '500',
  },
  activeNavLink: {
    backgroundColor: '#e6f2ff',
    color: '#0066cc',
  },
  userSection: {
    display: 'flex',
    alignItems: 'center',
    gap: '15px',
  },
  userInfo: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'flex-end',
  },
  userName: {
    fontWeight: '500',
    margin: 0,
  },
  userRole: {
    color: '#666',
    fontSize: '0.8rem',
    margin: 0,
  },
  userAvatar: {
    width: '35px',
    height: '35px',
    borderRadius: '50%',
    backgroundColor: '#0066cc',
    color: 'white',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    fontWeight: 'bold',
  },
  notificationIcon: {
    position: 'relative',
    cursor: 'pointer',
  },
  notificationBadge: {
    position: 'absolute',
    top: '-5px',
    right: '-5px',
    backgroundColor: '#ff4444',
    color: 'white',
    borderRadius: '50%',
    width: '18px',
    height: '18px',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    fontSize: '0.7rem',
  }
};

function Header({ currentPath }) {
  const user = {
    name: 'Admin CRM',
    role: 'Administrator',
    initials: 'A',
    notificationCount: 3,
  };

  // Fungsi untuk menentukan apakah link aktif
  const isActive = (path) => {
    if (path === '/') {
      return currentPath === '/';
    }
    return currentPath.startsWith(path);
  };

  return (
    <header style={headerStyles.header}>
      <Link to="/" style={headerStyles.logo}>
        <h1 style={headerStyles.logoText}>CRM Umroh</h1>
      </Link>
      
      <nav style={headerStyles.nav}>
        <Link 
          to="/" 
          style={{
            ...headerStyles.navLink,
            ...(isActive('/') ? headerStyles.activeNavLink : {})
          }}
        >
          Dashboard
        </Link>
        <Link 
          to="/jamaah" 
          style={{
            ...headerStyles.navLink,
            ...(isActive('/jamaah') ? headerStyles.activeNavLink : {})
          }}
        >
          Jamaah
        </Link>
        <Link 
          to="/paket" 
          style={{
            ...headerStyles.navLink,
            ...(isActive('/paket') ? headerStyles.activeNavLink : {})
          }}
        >
          Paket Umroh
        </Link>
        <Link 
          to="/pembayaran" 
          style={{
            ...headerStyles.navLink,
            ...(isActive('/pembayaran') ? headerStyles.activeNavLink : {})
          }}
        >
          Pembayaran
        </Link>
        <Link 
          to="/laporan" 
          style={{
            ...headerStyles.navLink,
            ...(isActive('/laporan') ? headerStyles.activeNavLink : {})
          }}
        >
          Laporan
        </Link>
      </nav>
      
      <div style={headerStyles.userSection}>
        <div style={headerStyles.notificationIcon}>
          <span role="img" aria-label="notification">🔔</span>
          {user.notificationCount > 0 && (
            <div style={headerStyles.notificationBadge}>
              {user.notificationCount}
            </div>
          )}
        </div>
        
        <div style={headerStyles.userInfo}>
          <p style={headerStyles.userName}>{user.name}</p>
          <p style={headerStyles.userRole}>{user.role}</p>
        </div>
        
        <div style={headerStyles.userAvatar}>
          {user.initials}
        </div>
      </div>
    </header>
  );
}

export default Header;